<template>
  <div class="carousel-slick slick-wrapper" id="carousel-slick">
    <slick ref="slick" :options="slickOptions">
      <lightbox v-for="image in images" v-bind:key="image.title" :caption="image.title" :src="image.src" :album="image.album"><img :src="image.src" /></lightbox>
    </slick>
  </div>
</template>

<script>
  import img01 from '@/assets/showcase_gap.png'
  import img02 from '@/assets/showcase_doritos.png'
  import img03 from '@/assets/showcase_keyg.png'
  import img04 from '@/assets/showcase_komaneko.png'
  import img05 from '@/assets/showcase_lastingimpressions.png'
  import Slick from 'vue-slick'
  import Lightbox from 'vue-lightbox'

  export default {
    name: 'carousel-slick',
    components: {
      Slick,
      Lightbox
    },
    data () {
      return {
        slickOptions: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          responsive: [
            {
              breakpoint: 1008,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true
              }
            }, {
              // 768 = tablet (not break yet)
              breakpoint: 769,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: true
              }
            }, {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: true
              }
            }
          ]
        },
        images: [
          {
            title: 'Lasting Impressions - http://lastingimpressions.noctorus.studio',
            src: img05,
            link: 'http://lastingimpressions.noctorus.studio',
            album: 'current'
          },
          {
            title: 'Gap',
            src: img01,
            link: '',
            album: 'current'
          },
          {
            title: 'Doritos',
            src: img02,
            link: '',
            album: 'current'
          },
          {
            title: 'keyG',
            src: img03,
            link: '',
            album: 'current'
          },
          {
            title: 'Komaneko',
            src: img04,
            link: '',
            album: 'current'
          }
        ]
      }
    },
    computed: {
    },
    watch: {
    },
    created () {
    },
    mounted () {
    },
    methods: {
      next () {
        this.$refs.slick.next()
      },
      prev () {
        this.$refs.slick.prev()
      },
      reInit () {
        this.$refs.slick.reSlick()
      }
    }
  }
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.carousel-slick {
}

/* slick */

.slick-prev, .slick-next {
  z-index: 100;
  width: 30px;
  height: 50px;
  background-color: $color-gray-mid;

  &:focus {
    background-color: $color-gray-mid;
  }

  &:hover {
    background-color: $color-gray-light;
  }

  &.slick-disabled {
    background-color: rgba(255,255,255,0.3);
  }

  &:before {
    content: '\279C';
  }
}

.slick-prev {
  left: 0px !important;
  top: calc(50% - 25px);
  -ms-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.slick-next {
  right: 0px !important;
}

.slick-dotted.slick-slider {
  margin-bottom: 0px;
}

.slick-dots {
  bottom: 10px;

  li {
    background-color: rgba(255,255,255,0.1);
    border-radius: 10px;

    &.slick-active button:before {
      opacity: 1.0;
      color: #ccc;
    }

    button:before {
      opacity: .40;
      color: lightgray;
    }
  }
}

.lb-image {
  width: auto !important
}

.lb-data .lb-caption a {
  color: $color-orange;
}

</style>



// WEBPACK FOOTER //
// CarouselSlick.vue?6e77e864